// セミナー関連
import commonClass from "./commonClass";

export default class seminarClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    // テンプレート
    this._$tmplTimeTable;
    this._$tmplTitle;
    this._$tmplInstructor;

    //カラーテンプレート表示
    this._$radio_colortmpl = $('.js-radio-smnr-colortmpl');
    this._radio_colortmpl = '.js-radio-smnr-colortmpl';
    this._colortmpl_wrap = '.js-smnr-colortmpl-wrap';
    this._colortmpl_prev = '.js-smnr-colortmpl-prev';

    // ブロック削除関連
    this._prtItem = '.js-smnr_prtItem';
    this._delItem = '.js-smnr_delItem';

     // 協賛を追加する
     this._smnrAddSponsor = '.js-smnr_addSponsor';
     this._$smnrAddSponsorArea = $('.js-smnr_addSponsorArea');

     // メディア協力を追加する
     this._smnrAddMedia = '.js-smnr_addMedia';
     this._$smnrAddMediaArea = $('.js-smnr_addMediaArea');

     // ゲストスピーカーを追加する
     this._smnrAddGuestSpeaker = '.js-smnr_addGuestSpeaker';
     this._$smnrAddGuestSpeakerArea = $('.js-smnr_addGuestSpeakerArea');

     // 展示概要
     this._smnrAddExhibition = '.js-smnr_addExhibition';
     this._$smnrAddExhibitionArea = $('.js-smnr_addExhibitionArea');
  }

  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._getTemplate();
    cls._initSeminar();

    // チェックボックスON/OFFでブロック全体をDisable（削除）にする
    APP.BlockDisable._setSelector(cls._delItem, cls._prtItem);
  }

  // テンプレート取得
  _getTemplate() {
    var cls = this;

    var $tmplSponsor = $('.js-smnr_sponsorTmpl');
    cls._$tmplSponsor = $tmplSponsor.clone().removeClass('js-smnr_sponsorTmpl');
    $tmplSponsor.remove();

    var $tmplMedia = $('.js-smnr_mediaTmpl');
    cls._$tmplMedia = $tmplMedia.clone().removeClass('js-smnr_mediaTmpl');
    $tmplMedia.remove();

    var $tmplGeastSpeaker = $('.js-smnr_geastspeakerTmpl');
    cls._$tmplGeastSpeaker = $tmplGeastSpeaker.clone().removeClass('js-smnr_geastspeakerTmpl');
    $tmplGeastSpeaker.remove();

    var $tmplExhibition = $('.js-smnr_exhibitionTmpl');
    cls._$tmplExhibition = $tmplExhibition.clone().removeClass('js-smnr_exhibitionTmpl');
    $tmplExhibition.remove();
  }

  _initSeminar() {
    var cls = this;

    //カラーテンプレート切り替え処理
    $(document).on('change', cls._radio_colortmpl, function() {
      var $wrap = $(this).parents(cls._colortmpl_wrap)
      var num = $wrap.find(cls._radio_colortmpl).index(this);

      $wrap.find(cls._colortmpl_prev).removeClass().addClass('js-smnr-colortmpl-prev smnr_colortmpl_prev_' + num);
    });

    // 協賛を追加する
    $(document).on('click', cls._smnrAddSponsor, function() {
      var $tmp = cls._$tmplSponsor.clone();
      $tmp.appendTo(cls._$smnrAddSponsorArea).fadeIn();

      return false;
    });

    // メディア協力を追加する
    $(document).on('click', cls._smnrAddMedia, function() {
      var $tmp = cls._$tmplMedia.clone();
      $tmp.appendTo(cls._$smnrAddMediaArea).fadeIn();

      return false;
    });
    
     // ゲストスピーカーを追加する
     $(document).on('click', cls._smnrAddGuestSpeaker, function() {
      var $tmp = cls._$tmplGeastSpeaker.clone();
      $tmp.appendTo(cls._$smnrAddGuestSpeakerArea).fadeIn();

      return false;
    });

    // 展示概要を追加する
    $(document).on('click', cls._smnrAddExhibition, function() {
      var $tmp = cls._$tmplExhibition.clone();
      $tmp.appendTo(cls._$smnrAddExhibitionArea).fadeIn();

      return false;
    });
  }
}